import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { EnterpriseShipping } from '@/screens/EnterpriseShipping';

export default function EnterpriseShippingPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="enterprise shipping, enterprise freight, enterprise shipping solutions, enterprise shipping softeware, enterprise freight management"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Enterprise Shipping Software | Loadsmart"
        description="Access instant, dynamic freight capacity to move your overland loads — no matter the mode or market."
        canonical="https://loadsmart.com/enterprise-shipping/"
        openGraph={{
          url: 'https://loadsmart.com/enterprise-shipping/',
        }}
      />
      <EnterpriseShipping />
    </>
  );
}
